import { render, staticRenderFns } from "./MiniList.vue?vue&type=template&id=83b2645c&scoped=true&"
import script from "./MiniList.vue?vue&type=script&lang=js&"
export * from "./MiniList.vue?vue&type=script&lang=js&"
import style0 from "./MiniList.vue?vue&type=style&index=0&id=83b2645c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b2645c",
  null
  
)

export default component.exports